import React from 'react';
import { Settings, AlertTriangle, RefreshCw, ServerOff } from 'lucide-react';
import { Button } from "../ui/button";
import { brand } from '../../config/brand';

export default function MaintenanceOverlay(): JSX.Element {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/95 backdrop-blur-md animate-in fade-in duration-500">
      <div className="max-w-md w-full mx-4">
        <div className="bg-card border border-border rounded-[2.5rem] p-10 shadow-2xl relative overflow-hidden group">
          {/* Animated Background Effect */}
          <div className="absolute inset-0 bg-primary/[0.02] group-hover:bg-primary/[0.04] transition-all duration-700" />
          
          <div className="relative flex flex-col items-center text-center space-y-8">
            <div className="relative">
              <div className="h-24 w-24 rounded-[2rem] bg-primary/10 border border-primary/20 flex items-center justify-center shadow-xl relative z-10">
                <ServerOff className="h-10 w-10 text-primary animate-pulse" />
              </div>
              <div className="absolute -top-2 -right-2 bg-amber-500 rounded-full p-2 border-4 border-[#1e293b] z-20 animate-bounce">
                <AlertTriangle className="h-4 w-4 text-[#0f172a]" />
              </div>
            </div>

            <div className="space-y-3">
              <h1 className="text-3xl font-black text-foreground tracking-tight italic uppercase">
                System Offline
              </h1>
              <div className="h-1 w-20 bg-primary mx-auto rounded-full" />
              <p className="text-muted-foreground font-medium leading-relaxed mt-4">
                We're currently undergoing scheduled maintenance or the server is temporarily unreachable.
              </p>
              <p className="text-primary text-sm font-black uppercase tracking-[0.2em] mt-2">
                We will be back shortly
              </p>
            </div>

            <div className="flex flex-col gap-4 w-full pt-4">
              <Button 
                onClick={handleReload}
                className="bg-primary hover:bg-primary/90 text-white font-black h-14 rounded-2xl shadow-lg shadow-primary/20 gap-3 group/btn"
              >
                <RefreshCw className="h-5 w-5 group-hover/btn:rotate-180 transition-transform duration-500" />
                RETRY CONNECTION
              </Button>
              
              <div className="flex items-center justify-center gap-2 text-[10px] font-black text-muted-foreground uppercase tracking-widest">
                <div className="h-1.5 w-1.5 rounded-full bg-muted animate-pulse" />
                Status: Checking Infrastructure
              </div>
            </div>
          </div>
        </div>
        
        {/* Footer info */}
        <p className="text-center mt-8 text-muted-foreground text-xs font-bold uppercase tracking-[0.3em]">
          {brand.name} • {brand.tagline}
        </p>
      </div>
    </div>
  );
}

